import React, { useState } from 'react';
import ButtonOptions from '../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../components/NovoSistema/HeaderButtons';
import Indicadores from './Indicadores';
import TOC from './TOC';

export default function GestaoDeCustos() {
  const [option, setOption] = useState('');
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Honorários Médicos"
          border="#079992"
          active={option === 'Honorários Médicos' ? true : false}
          yourFunction={() => setOption('Honorários Médicos')}
        />
        <ButtonOptions
          buttonName="Pessoal Assistencial"
          border="#079992"
          active={option === 'Pessoal Assistencial' ? true : false}
          yourFunction={() => setOption('Pessoal Assistencial')}
        />
        <ButtonOptions
          buttonName="Pessoal Adm"
          border="#079992"
          active={option === 'Pessoal Adm' ? true : false}
          yourFunction={() => setOption('Pessoal Adm')}
        />
        <ButtonOptions
          buttonName="Materiais"
          border="#079992"
          active={option === 'Materiais' ? true : false}
          yourFunction={() => setOption('Materiais')}
        />
        <ButtonOptions
          buttonName="Medicamentos"
          border="#079992"
          active={option === 'Medicamentos' ? true : false}
          yourFunction={() => setOption('Medicamentos')}
        />
        <ButtonOptions
          buttonName="Tempo e Movimento"
          border="#079992"
          active={option === 'Tempo e Movimento' ? true : false}
          yourFunction={() => setOption('Tempo e Movimento')}
        />
        <ButtonOptions
          buttonName="Compras Regulares"
          border="#079992"
          active={option === 'Compras Regulares' ? true : false}
          yourFunction={() => setOption('Compras Regulares')}
        />
        <ButtonOptions
          buttonName="Compras Emergenciais"
          border="#079992"
          active={option === 'Compras Emergenciais' ? true : false}
          yourFunction={() => setOption('Compras Emergenciais')}
        />
        <ButtonOptions
          buttonName="Obsolescência"
          border="#079992"
          active={option === 'Obsolescência' ? true : false}
          yourFunction={() => setOption('Obsolescência')}
        />
        <ButtonOptions
          buttonName="Perdas"
          border="#079992"
          active={option === 'Perdas' ? true : false}
          yourFunction={() => setOption('Perdas')}
        />
        <ButtonOptions
          buttonName="Diárias"
          border="#079992"
          active={option === 'Diárias' ? true : false}
          yourFunction={() => setOption('Diárias')}
        />
        <ButtonOptions
          buttonName="Taxas"
          border="#079992"
          active={option === 'Taxas' ? true : false}
          yourFunction={() => setOption('Taxas')}
        />
        <ButtonOptions
          buttonName="Indicadores"
          border="#079992"
          active={option === 'Indicadores' ? true : false}
          yourFunction={() => setOption('Indicadores')}
        />
        <ButtonOptions
          buttonName="TOC"
          border="#079992"
          active={option === 'TOC' ? true : false}
          yourFunction={() => setOption('TOC')}
        />
      </HeaderButtons>
      {option === 'Honorários Médicos' && <div></div>}
      {option === 'Pessoal Assistencial' && <div></div>}
      {option === 'Pessoal Adm' && <div></div>}
      {option === 'Materiais' && <div></div>}
      {option === 'Medicamentos' && <div></div>}
      {option === 'Tempo e Movimento' && <div></div>}
      {option === 'Compras Regulares' && <div></div>}
      {option === 'Compras Emergenciais' && <div></div>}
      {option === 'Obsolescência' && <div></div>}
      {option === 'Perdas' && <div></div>}
      {option === 'Diárias' && <div></div>}
      {option === 'Taxas' && <div></div>}
      {option === 'Indicadores' && <Indicadores />}
      {option === 'TOC' && <TOC />}
    </main>
  );
}
